exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-bar {\n    margin-bottom: 20px;\n}\n", ""]);

// exports
